export default function IntroText () {
  const SECTIONS = document.querySelectorAll('.dm-intro')
  if (SECTIONS.length > 0) {
    for (let i = 0; i < SECTIONS.length; i++) {
      const SECTION = SECTIONS[i]
      const BUTTON = SECTION.querySelector('.dm-intro__button')
      BUTTON && BUTTON.addEventListener('click', () => {
        SECTION.classList.remove('dm-intro--show-overlay')
      })
    }
  }
}